import './Control.css';
import { toast } from "react-toastify";
import utils from "../services/utilsServices";
import cardService from "../services/cardServices";
import React, { useContext, useEffect, useState } from "react";
import lock from '../Images/lock.png'
import unLock from '../Images/unLock.png'
import doorOpen from '../Images/doorOpen.png'
import soundOff from '../Images/soundOff.png'
import { MainContext } from "../store/mainContext";
//import { MenuBottomGeo } from "./MenuBottomGeo";
import { useNavigate } from 'react-router-dom';
export default function Control() {
    let navigate = useNavigate();
    const { defaultDevice, setDefaultDevice } = useContext(MainContext);
    useEffect(() => {
        const list = cardService.getCard();
        if (defaultDevice == null && list == []) {
            toast.warn('ابتدا دستگاه را اضافه کنید', { theme: "colored" });
            navigate('/main');
            return;
        } else if (defaultDevice == null && list != []) {
            toast.warn('ابتدا دستگاه را انتخاب کنید', { theme: "colored" });
            navigate('/main');
            return;
        }
    }, []);


    const doItem = (e, state) => {
        e.preventDefault();
        if (state == 1)
            utils.sendSms(defaultDevice.deviceNumber, `lock`);
        else if (state == 2)
            utils.sendSms(defaultDevice.deviceNumber, `unlock`)
        else if (state == 3)
            utils.sendSms(defaultDevice.deviceNumber, `trunk`)
        else if (state == 4)
            utils.sendSms(defaultDevice.deviceNumber, `mute`)
        toast.success(utils.waitSms);
    }



    return (
        <>

            <div className="container-fluid">
                <div className="row" >
                    <div className="col justify-content-center" id="parentCol">
                        <div className=" " id="parentControl">
                            <div className="row">
                                <div className="col justify-content-center d-flex">
                                    <button className="btn" onClick={(e) => doItem(e, 1)}>
                                        <img src={lock} />
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col justify-content-center d-flex">
                                    <button className="btn  " onClick={(e) => doItem(e, 2)}>
                                        <img src={unLock} />
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col justify-content-center d-flex">
                                    <button className="btn  " onClick={(e) => doItem(e, 3)}>
                                        <img src={doorOpen} />
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col justify-content-center d-flex">
                                    <button className="btn  " onClick={(e) => doItem(e, 4)}>
                                        <img src={unLock} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*          <MenuBottomGeo />*/}
        </>

    );



}